import { combineReducers } from 'redux';
import * as actionTypes from '../action-mgr/actionTypes';

import downloadForm from './DownloadFormReducers';
import downloadData from './DownloadDataSelectReducers';
import downloadReport from './DownloadReportSelectReducers'
import downloadConfig from './DownloadConfigSelectReducers'

const byId = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.FETCH_USER_DOWNLOAD_REQUESTS_SUCCESS:
      return action.byId;
    case actionTypes.CREATE_DOWNLOAD_REQUEST_SUCCESS:
    case actionTypes.FETCH_BY_IDS_SUCCESS:
      return {
        ...state,
        ...action.byId
      };
    default:
      return state;
  }
}

const stnAvaliableTime = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.DOWNLOAD_AVALIABLE_TIME_FAIL:
      return action.message;
    case actionTypes.DOWNLOAD_AVALIABLE_TIME_SUCCESS:
      return action.data;
    default:
      return state;
  }
}

const ids = (state = [], action) => {
  switch (action.type) {
    case actionTypes.FETCH_USER_DOWNLOAD_REQUESTS_SUCCESS:
      return action.ids;
    case actionTypes.CREATE_DOWNLOAD_REQUEST_SUCCESS:
      return [
        ...state,
        action.ids
      ];
    case actionTypes.DELETE_DOWNLOAD_REQUEST_SUCCESS:
      return [
        ...state.slice(0, action.index),
        ...state.slice(action.index + 1)
      ];
    default:
      return state;
  }
}

const isSubmitting = (state = false, action) => {
  switch (action.type) {
    case actionTypes.CREATE_DOWNLOAD_REQUEST_REQUEST:
      return true;
    case actionTypes.CREATE_DOWNLOAD_REQUEST_FAILURE:
    case actionTypes.CREATE_DOWNLOAD_REQUEST_SUCCESS:
      return false;
    default:
      return state;
  }
}

const isDownloading = (state = false, action) => {
  switch (action.type) {
    case actionTypes.DOWNLOAD_FILE_REQUEST:
      return true;
    case actionTypes.DOWNLOAD_FILE_SUCCESS:
    case actionTypes.DOWNLOAD_FILE_FAILURE:
      return false;
    default:
      return state;
  }
}

const isDeleting = (state = false, action) => {
  switch (action.type) {
    case actionTypes.DELETE_DOWNLOAD_REQUEST_REQUEST:
      return true;
    case actionTypes.DELETE_DOWNLOAD_REQUEST_SUCCESS:
    case actionTypes.DELETE_DOWNLOAD_REQUEST_FAILURE:
      return false;
    default:
      return state;
  }
}

const fetchInterval = (state = 0, action) => {
  switch (action.type) {
    case actionTypes.SET_FETCH_INTERVAL:
      return action.interval;
    case actionTypes.CLEAR_FETCH_INTERVAL:
      return 0;
    default:
      return state;
  }
}

const isSearching = (state = false, action) => {
  switch (action.type) {
    case actionTypes.DOWNLOAD_AVALIABLE_TIME:
      return true;
    case actionTypes.DOWNLOAD_AVALIABLE_TIME_SUCCESS:
    case actionTypes.DOWNLOAD_AVALIABLE_TIME_FAIL:
      return false;
    default:
      return state;
  }
}

export default combineReducers({
  byId,
  ids,
  downloadForm,
  downloadData,
  downloadReport,
  downloadConfig,
  isSubmitting,
  isDownloading,
  fetchInterval,
  isDeleting,
  stnAvaliableTime,
  isSearching,
});

const getCurrentState = state => state.downloadRequests;

export const getDownloadRequests = state => {
  const { byId, ids } = getCurrentState(state);
  return ids.map(id => byId[id]);
}

export const getIsSubmitting = state => getCurrentState(state).isSubmitting;

export const getIsDownloading = state => getCurrentState(state).isDownloading;

export const getFetchInterval = state => getCurrentState(state).fetchInterval;

export const getIsDeleting = state => getCurrentState(state).isDeleting;

export const getStnAvaliableTime = state => getCurrentState(state).stnAvaliableTime;

export const getisSearching = state => getCurrentState(state).isSearching;